import React from "react";
import "./DashboardHome.css";
import { useNavigate } from "react-router-dom";

/* === IMPORT 3 IMAGES === */
import rcPic from "../assets/rcpic.jpg";
import dlPic from "../assets/dlpic.jpg";
import panPic from "../assets/panpic.jpg";
import mobser from "../assets/mobser.png";

const DashboardHome = () => {
  const user = JSON.parse(localStorage.getItem("user"));
  const navigate = useNavigate();

  const cards = [
    { title: "RC Services", path: "/dashboard/rc-services", img: rcPic },
    { title: "DL Services", path: "/dashboard/dl-services", img: dlPic },
    { title: "PAN Services", path: "/dashboard/pan-services", img: panPic },
    { title: "Mobile Services", path: "/dashboard/mob-services", img: mobser }
  ];

  return (
    <div className="dash-home">

      <h2 className="welcome">
        Welcome {user?.first_name} {user?.surname || user?.last_name} 👋
      </h2>

      {/* ================= PRICING TABLE ================= */}
      <h3 className="price-title">Pricing List</h3>

      <table className="price-table">
        <thead>
          <tr>
            <th>Service Name</th>
            <th>Price</th>
            <th>Service Name</th>
            <th>Price</th>
          </tr>
        </thead>

        <tbody>
          <tr>
            <td>RC Owner PDF</td>
            <td>₹99/-</td>
            <td>RC Registered Mobile No.</td>
            <td>₹50/-</td>
          </tr>

          <tr>
            <td>Rc Particulars</td>
            <td>₹99/-</td>
            <td>Aadhar to Pan card No.</td>
            <td>₹50/-</td>
          </tr>

          <tr>
            <td>DL Instant PDF</td>
            <td>₹149/-</td>
            <td>RC PDF 2 Server</td>
            <td>₹99/-</td>
          </tr>

          <tr>
            <td>Pan Advanced Details</td>
            <td>₹75/-</td>
            <td>Pan Basic Details</td>
            <td>₹35/-</td>
          </tr>
            <tr>
            <td>Rc Basics Details</td>
            <td>₹35/-</td>
            <td>Chassis to Vehicle No.</td>
            <td>₹65/-</td>
          </tr>
             <tr>
            <td>Mobile No. to Details</td>
            <td>₹350/-</td>
            <td>Mobile No. to Details Server 2</td>
            <td>₹350/-</td>
          </tr>
        </tbody>
      </table>

      <h2 className="services-title-bar">ALL NEW SERVICES</h2>

      {/* ================= SERVICE CARDS ================= */}
      <div className="home-card-box">

        {cards.map((c, i) => (
          <div className="home-card" key={i} onClick={() => navigate(c.path)}>
            
            {/* IMAGE TOP (DIFFERENT SIZE) */}
            <img 
              src={c.img} 
              alt={c.title} 
              className={`home-card-img-top img-${i}`}
            />

            <h3 className="home-card-title">{c.title}</h3>

            <button className="home-card-btn">
              Open
            </button>

          </div>
        ))}

      </div>

    </div>
  );
};

export default DashboardHome;
